export default __webpack_public_path__ + "static/media/buffer.36e6961d.png";